var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[(this.urlAddress || this.documentContent)?_c('iframe',{staticClass:"content-iframe",attrs:{"id":"iframe","src":this.urlAddress,"srcDoc":this.documentContent}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }